module.exports = __webpack_public_path__ + "img/db2.bbbf4043.jpg";